<template>
  <div class="modern-header" id="header">
    <div class="header-container">
      <router-link to="/" class="logo-container">
        <img
          src="@/assets/images/Universitätsmedizin-Göttingen-Logo.svg.png"
          alt="Universitätsmedizin Göttingen Logo"
          class="umg-logo"
        >
      </router-link>

      <input type="checkbox" id="menu-toggle" class="menu-toggle" aria-hidden="true">
      <label for="menu-toggle" class="hamburger">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </label>

      <nav class="navigation">
        <ul>
          <li :class="{'active': route.path === '/'}">
            <router-link to="/">Projects</router-link>
          </li>
          <li :class="{'active': route.path === '/contact'}">
            <router-link to="/contact">Contact</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup lang="js">
import { useRoute } from "vue-router";
const route = useRoute();
</script>

<style scoped>
:root {
  --primary: #2563eb;
  --primary-light: #dbeafe;
  --dark: #0f172a;
  --light: #f8fafc;
  --gray: #64748b;
  --transition: all 0.3s ease;
}

.modern-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.logo-container {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: var(--transition);
}

.umg-logo {
  height: 50px;
  width: auto;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.05));
  transition: var(--transition);
}

.umg-logo:hover {
  transform: scale(1.02);
}

/* Navigation Styles */
.navigation ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2.5rem;
}

.navigation a {
  text-decoration: none;
  font-weight: 500;
  font-size: 1.05rem;
  color: var(--gray);
  padding: 0.75rem 0;
  position: relative;
  transition: var(--transition);
}

.navigation a:hover {
  color: var(--dark);
}

.navigation a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--primary);
  transition: var(--transition);
}

.navigation a:hover::after {
  width: 100%;
}

.navigation li.active a {
  color: var(--dark);
  font-weight: 600;
}

.navigation li.active a::after {
  width: 100%;
}

/* Hamburger Menu */
.menu-toggle {
  display: none;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
  visibility: hidden;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  gap: 0.4rem;
}

.bar {
  width: 24px;
  height: 2.5px;
  background: var(--dark);
  border-radius: 2px;
  transition: var(--transition);
}

/* Responsive Design */
@media (max-width: 992px) {
  .navigation ul {
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .navigation {
    position: fixed;
    top: 80px;
    right: -100%;
    width: 80%;
    height: calc(100vh - 80px);
    background: white;
    box-shadow: -5px 0 25px -5px rgba(0, 0, 0, 0.1);
    transition: var(--transition);
    z-index: 99;
  }

  .navigation ul {
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    gap: 1.5rem;
    height: 100%;
  }

  .navigation a {
    font-size: 1.25rem;
    padding: 0.75rem 0;
  }

  .menu-toggle:checked ~ .navigation {
    right: 0;
  }

  .hamburger {
    display: flex;
  }

  .menu-toggle:checked ~ .hamburger .bar:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }

  .menu-toggle:checked ~ .hamburger .bar:nth-child(2) {
    opacity: 0;
  }

  .menu-toggle:checked ~ .hamburger .bar:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }
}

@media (max-width: 480px) {
  .header-container {
    padding: 0 1.5rem;
  }

  .umg-logo {
    height: 45px;
  }

  .navigation a {
    font-size: 1.35rem;
  }
}
</style>
